import React from "react";

// Top-level safety net. Any uncaught render error (e.g. a stale/expired session
// hitting a code path that formats missing data) becomes a graceful "sign in again"
// screen instead of a blank white page. Clearing the token on reload sends the user
// cleanly back to login, which is the usual cause.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Intentionally quiet (console is suppressed in production). Hook kept for
    // future error reporting if you add it.
  }

  handleReload = () => {
    try {
      localStorage.removeItem("userValue");
    } catch (e) {
      /* ignore */
    }
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
            padding: "24px",
            background: "#0f1012",
            color: "#f5f5f5",
            fontFamily:
              "'Outfit', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "44px" }} aria-hidden="true">
            ⏳
          </div>
          <h1 style={{ margin: 0, fontSize: "22px", fontWeight: 600 }}>
            Your session has ended
          </h1>
          <p
            style={{
              margin: 0,
              maxWidth: "420px",
              opacity: 0.75,
              lineHeight: 1.5,
            }}
          >
            Something interrupted your session. Please sign in again to continue —
            your data is safe.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: "6px",
              padding: "11px 22px",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontSize: "15px",
              fontWeight: 600,
              color: "#1a1400",
              background: "linear-gradient(180deg, #f4d27c, #c0922e)",
            }}
          >
            Log in again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
